// Editable landing-page content. Change copy, pricing and FAQ here.
import { Ban, ShieldCheck, Eye, HeartHandshake } from "lucide-react";

export const TRUST_CARDS = [
  { icon: Ban, title: "No ads, ever", body: "We never show ads and we never sell your family's data." },
  { icon: ShieldCheck, title: "Math-only tutor", body: "The AI tutor only talks about math and stays on-topic. Off-topic or unsafe messages are declined." },
  { icon: Eye, title: "Full transparency", body: "Parents can read every tutor conversation, any time, in the parent dashboard." },
  { icon: HeartHandshake, title: "Built with COPPA in mind", body: "Parents create the account and give consent; children only need a first name or nickname." },
];

// Pricing — real plans wired to Stripe lookup keys. Free Trial is the free signup
// path (no charge). Paid plans support monthly + annual billing.
export const PRICING = {
  note: "Private tutors typically cost $50–80/hour. Start free, upgrade anytime.",
  trialNoCard: true,
  cancelAnytime: true,
  plans: [
    {
      id: "trial", name: "Free Trial", monthly: 0, yearly: 0,
      highlight: false, cta: "Start free", free: true,
      features: ["14-day full access", "Full diagnostic", "Socratic AI tutor", "Parent dashboard"],
    },
    {
      id: "monthly", name: "Monthly", monthly: 14.99, yearly: 149,
      highlight: true, cta: "Choose Monthly",
      lookupMonthly: "monthly_monthly", lookupYearly: "monthly_yearly",
      features: ["One child", "Everything in Free Trial", "Unlimited practice & reviews", "Weekly parent reports"],
    },
    {
      id: "family", name: "Family Plan", monthly: 24.99, yearly: 249,
      highlight: false, cta: "Choose Family",
      lookupMonthly: "family_monthly", lookupYearly: "family_yearly",
      features: ["Up to 4 children", "All Monthly features", "Shared parent dashboard", "Priority support"],
    },
  ],
};

export const FAQ = [
  {
    q: "How is NumberSense different from Khan Academy or IXL?",
    a: "NumberSense is mastery- and prerequisite-first: a short adaptive diagnostic finds the real gaps, then builds a plan that unlocks skills only once the ideas beneath them are solid. The Socratic AI tutor guides with questions instead of handing over answers, and parents see every tutor conversation. [VERIFY competitor comparison claims]",
  },
  {
    q: "What if my child is ahead of or behind grade level?",
    a: "The diagnostic places your child by prerequisite, not just by grade, so an advanced child moves ahead and a child with gaps revisits foundations first — without judgment.",
  },
  {
    q: "Is it aligned to Common Core / state standards?",
    a: "Our grades 3–8 skill graph is organized around widely-taught math progressions. [VERIFY exact Common Core / state-standard alignment before making a formal claim]",
  },
  {
    q: "Does the AI tutor just give my child the answers?",
    a: "No. The tutor is Socratic by design — it asks the next good question, surfaces the misconception, and offers hints, but it will not simply give the final answer.",
  },
  {
    q: "How much time does it take each day?",
    a: "A calm daily loop of about 10–15 minutes: one short lesson, a little practice, and quick spaced review. [VERIFY typical session length with real usage data]",
  },
  {
    q: "What devices does it work on?",
    a: "NumberSense is mobile-first and runs in any modern browser on phones, tablets, Chromebooks and computers — nothing to install.",
  },
  {
    q: "How do you protect my child's data?",
    a: "Parents create the account and give consent; children only need a first name or nickname. We show no ads and never sell family data, and the tutor is restricted to math. See our privacy policy for details. [VERIFY data-retention and sub-processor specifics with legal counsel]",
  },
];

export const FOUNDER = {
  name: "[FOUNDER NAME]",
  credentials: "[CREDENTIALS]",
  story: "[STORY — 2–3 sentences on why we built NumberSense]",
};

export const FOOTER_LINKS = [
  { label: "About", to: "/about" },
  { label: "Pricing", to: "/#pricing" },
  { label: "FAQ", to: "/#faq" },
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Terms of Service", to: "/terms" },
  { label: "Contact", to: "/contact" },
  { label: "For Schools & Homeschoolers", to: "/about" },
];
